export default "__VITE_ASSET__DUTO_xI$__"